import { useTranslation } from 'react-i18next'
import { Checkbox } from '@/components/ui/checkbox'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import type {
  ResolutionBand,
  ResolutionBandId,
  ResolutionSummary,
} from '@/services/api/entity-resolution-assistant'
import { bulkEligibleGroups } from './resolution-identity'

const COPY = 'resolutionAssistant'
export interface BandSelection {
  ids: ResolutionBandId[]
  disabled: boolean
  toggle: (id: ResolutionBandId, selected: boolean) => void
}

export function ResolutionBandTable({
  summary,
  selection,
}: {
  summary: ResolutionSummary
  selection: BandSelection
}) {
  const { t } = useTranslation()
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>{t(`${COPY}.similarity`)}</TableHead>
          <TableHead className="text-right">{t(`${COPY}.eligibleGroups`)}</TableHead>
          <TableHead className="text-right">{t(`${COPY}.entities`)}</TableHead>
          <TableHead className="text-right">{t(`${COPY}.share`)}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {summary.bands.map(band => (
          <BandRow key={band.id} band={band} selection={selection} />
        ))}
      </TableBody>
    </Table>
  )
}

function BandRow({ band, selection }: { band: ResolutionBand; selection: BandSelection }) {
  const { t, i18n } = useTranslation()
  const label = t(`${COPY}.bands.${band.id}`)
  return (
    <TableRow>
      <TableCell>
        <label className="flex cursor-pointer items-center gap-2">
          <Checkbox
            aria-label={t(`${COPY}.selectBand`, { band: label })}
            checked={selection.ids.includes(band.id)}
            disabled={selection.disabled || band.id === 'unknown' || bulkEligibleGroups(band) === 0}
            onCheckedChange={checked => selection.toggle(band.id, checked === true)}
          />
          <span className="whitespace-nowrap">{label}</span>
        </label>
      </TableCell>
      <TableCell className="text-right tabular-nums">
        {band.bulk_eligible_group_count === undefined ? '—' : bulkEligibleGroups(band)} /{' '}
        {band.group_count}
      </TableCell>
      <TableCell className="text-right tabular-nums">{band.candidate_count}</TableCell>
      <TableCell className="text-right tabular-nums">
        {band.percentage.toLocaleString(i18n.language, { maximumFractionDigits: 1 })}%
      </TableCell>
    </TableRow>
  )
}
